import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import i18n from 'i18n-js';
import Box from '@material-ui/core/Box';
import { BaseModal } from 'components/UI';
import { DateTimePickerField } from 'components/FormFields';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const Exchange = ({ open, action, handleClick, subscription }) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [initialValues, setInitialValues] = useState({
    action_time: '',
    action: '',
    exchange_event: '',
  });

  const { errors, fetchedUpdateExchange, fetchingUpdateExchange } = useSelector(
    (state) => state.subscriptions
  );

  const setActionData = () => {
    switch (action) {
      case 'schedule_delivery':
        setInitialValues({
          action: 'SCHEDULEEXCHANGE',
          action_time:
            subscription?.exchanges?.START?.used_time ||
            subscription?.exchanges?.START?.reserved_time ||
            new Date(),
          exchange_event: 'START',
        });
        break;

      case 'mark_delivered':
        setInitialValues({
          action: 'COMPLETEEXCHANGE',
          action_time: subscription?.exchanges?.START?.exchange_time || new Date(),
          exchange_event: 'START',
        });
        break;

      case 'schedule_return':
        setInitialValues({
          action: 'SCHEDULEEXCHANGE',
          action_time:
            subscription?.exchanges?.END?.used_time ||
            subscription?.exchanges?.END?.reserved_time ||
            new Date(),
          exchange_event: 'END',
        });
        break;

      case 'mark_returned':
        setInitialValues({
          action: 'COMPLETEEXCHANGE',
          action_time: subscription?.exchanges?.END?.exchange_time || new Date(),
          exchange_event: 'END',
        });
        break;

      default:
        break;
    }
  };

  const ExchangeSchema = Yup.object().shape({
    action_time: Yup.string().required(i18n.t('common.required_field')),
    action: Yup.string(),
    exchange_event: Yup.string(),
  });

  useEffect(() => {
    setActionData();
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!fetchingUpdateExchange && fetchedUpdateExchange) {
      dispatch(SubscriptionsActions.resetExchangeSubscription());
      handleClick();
    }
  }, [fetchedUpdateExchange, fetchingUpdateExchange]); // eslint-disable-line

  const submit = (values) => {
    dispatch(SubscriptionsActions.fetchUpdateExchange(subscription?.id, values));
  };

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      loading={fetchingUpdateExchange}
      enterButtonLabel={i18n.t('common.save')}
      title={i18n.t(`actions.${action}`)}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        innerRef={formRef}
        validationSchema={ExchangeSchema}
        onSubmit={submit}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Box mt={1}>
              <Field
                name="action_time"
                component={DateTimePickerField}
                asyncErrors={errors?.action_time || errors?.action || errors?.exchange_event}
                label={i18n.t('common.enter_date')}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

Exchange.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  action: PropTypes.string,
  subscription: PropTypes.any,
};

Exchange.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default Exchange;
